// extracted by mini-css-extract-plugin
module.exports = {"DraftTitle":"DraftTitle_DraftTitle__3pabv"};